module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.18d44f79.ttf";